<div [class.add-acs-codes-modal]="modalConfig?.title === 'Add ACS Codes'">
    <app-select-acs-codes [(options)]="options"></app-select-acs-codes>
</div>
